<template>
  <div>Цирковая статистика</div>
</template>

<script>
  export default {
    name: "Circus"
  }
</script>

<style scoped>

</style>
